export default "__VITE_ASSET__SsxuZdgz__"